import { ADDON_ID, PANEL_ID, PARAM_KEY, CLEAR_ID, EVENT_ID } from './chunk-J7AIPJJH.mjs';
import React, { Component, Fragment } from 'react';
import { addons, types, useAddonState, useChannel } from '@storybook/manager-api';
import { STORY_CHANGED } from '@storybook/core-events';
import { ScrollArea, Spaced, ActionBar, Badge } from '@storybook/components';
import { dequal } from 'dequal';
import { styled, withTheme } from '@storybook/theming';
import { Inspector } from 'react-inspector';
import { opacify } from 'polished';

var Action = styled.div({
  display: "flex",
  padding: 0,
  borderLeft: "5px solid transparent",
  borderBottom: "1px solid transparent",
  transition: "all 0.1s",
  alignItems: "flex-start",
  whiteSpace: "pre"
});
var Counter = styled.div(({ theme }) => ({
  backgroundColor: opacify(0.5, theme.appBorderColor),
  color: theme.color.inverseText,
  fontSize: theme.typography.size.s1,
  fontWeight: theme.typography.weight.bold,
  lineHeight: 1,
  padding: "1px 5px",
  borderRadius: 20,
  margin: "2px 0px"
}));
var InspectorContainer = styled.div({
  flex: 1,
  padding: "0 0 0 5px"
});

// src/components/ActionLogger/index.tsx
var UnstyledWrapped = ({ children, className }) => /* @__PURE__ */ React.createElement(ScrollArea, { horizontal: true, vertical: true, className }, children);
var Wrapper = styled(UnstyledWrapped)({
  margin: 0,
  padding: "10px 5px 20px"
});
var ThemedInspector = withTheme(({ theme, ...props }) => /* @__PURE__ */ React.createElement(Inspector, { theme: theme.addonActionsTheme || "chromeLight", table: false, ...props }));
var ActionLogger = ({ actions, onClear }) => /* @__PURE__ */ React.createElement(Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, null, actions.map((action) => /* @__PURE__ */ React.createElement(Action, { key: action.id }, action.count > 1 && /* @__PURE__ */ React.createElement(Counter, null, action.count), /* @__PURE__ */ React.createElement(InspectorContainer, null, /* @__PURE__ */ React.createElement(
  ThemedInspector,
  {
    sortObjectKeys: true,
    showNonenumerable: false,
    name: action.data.name,
    data: action.data.args || action.data
  }
))))), /* @__PURE__ */ React.createElement(ActionBar, { actionItems: [{ title: "Clear", onClick: onClear }] }));

// src/containers/ActionLogger/index.tsx
var safeDeepEqual = (a, b) => {
  try {
    return dequal(a, b);
  } catch (e) {
    return false;
  }
};
var ActionLogger2 = class extends Component {
  constructor(props) {
    super(props);
    this.handleStoryChange = () => {
      const { actions } = this.state;
      if (actions.length > 0 && actions[0].options.clearOnStoryChange) {
        this.clearActions();
      }
    };
    this.addAction = (action) => {
      this.setState((prevState) => {
        const actions = [...prevState.actions];
        const previous = actions.length && actions[0];
        if (previous && safeDeepEqual(previous.data, action.data)) {
          previous.count++;
        } else {
          action.count = 1;
          actions.unshift(action);
        }
        return { actions: actions.slice(0, action.options.limit) };
      });
    };
    this.clearActions = () => {
      const { api } = this.props;
      api.emit(CLEAR_ID);
      this.setState({ actions: [] });
    };
    this.mounted = false;
    this.state = { actions: [] };
  }
  componentDidMount() {
    this.mounted = true;
    const { api } = this.props;
    api.on(EVENT_ID, this.addAction);
    api.on(STORY_CHANGED, this.handleStoryChange);
  }
  componentWillUnmount() {
    this.mounted = false;
    const { api } = this.props;
    api.off(STORY_CHANGED, this.handleStoryChange);
    api.off(EVENT_ID, this.addAction);
  }
  render() {
    const { actions = [] } = this.state;
    const { active } = this.props;
    const props = {
      actions,
      onClear: this.clearActions
    };
    return active ? /* @__PURE__ */ React.createElement(ActionLogger, { ...props }) : null;
  }
};

// src/manager.tsx
function Title() {
  const [{ count }, setCount] = useAddonState(ADDON_ID, { count: 0 });
  useChannel({
    [EVENT_ID]: () => {
      setCount((c) => ({ ...c, count: c.count + 1 }));
    },
    [STORY_CHANGED]: () => {
      setCount((c) => ({ ...c, count: 0 }));
    },
    [CLEAR_ID]: () => {
      setCount((c) => ({ ...c, count: 0 }));
    }
  });
  const suffix = count === 0 ? "" : /* @__PURE__ */ React.createElement(Badge, { status: "neutral" }, count);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Spaced, { col: 1 }, /* @__PURE__ */ React.createElement("span", { style: { display: "inline-block", verticalAlign: "middle" } }, "Actions"), suffix));
}
addons.register(ADDON_ID, (api) => {
  addons.add(PANEL_ID, {
    title: Title,
    type: types.PANEL,
    render: ({ active }) => /* @__PURE__ */ React.createElement(ActionLogger2, { api, active: !!active }),
    paramKey: PARAM_KEY
  });
});
